/* ==========================================================================
   RAW Energy — Tripwire product template
   Shared vanilla JS controllers (no libraries)
   ========================================================================== */
(function () {
  'use strict';

  /* Varias secciones tw- incluyen este mismo <script src>, así que el archivo
     puede ejecutarse más de una vez en la misma página. Sin este guardia, los
     listeners quedarían duplicados y se anularían entre sí (doble toggle). */
  if (window.__twProductJsLoaded) return;
  window.__twProductJsLoaded = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------------------------------------------------------------
     Countdown — [data-tw-countdown][data-end="ISO date"]
     Hides its container permanently once it reaches zero. No looping.
  --------------------------------------------------------------------- */
  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-tw-countdown]');
    nodes.forEach(function (node) {
      var endValue = node.getAttribute('data-end');
      var endTime = endValue ? new Date(endValue).getTime() : NaN;
      var hrsEl = node.querySelector('[data-tw-hrs]');
      var minEl = node.querySelector('[data-tw-min]');
      var secEl = node.querySelector('[data-tw-sec]');
      var wrapper = node.closest('[data-tw-countdown-wrapper]') || node;

      if (!endTime || isNaN(endTime)) {
        wrapper.hidden = true;
        return;
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        var now = Date.now();
        var diff = endTime - now;

        if (diff <= 0) {
          wrapper.hidden = true;
          clearInterval(timer);
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var hrs = Math.floor(totalSeconds / 3600);
        var mins = Math.floor((totalSeconds % 3600) / 60);
        var secs = totalSeconds % 60;

        if (hrsEl) hrsEl.textContent = pad(hrs);
        if (minEl) minEl.textContent = pad(mins);
        if (secEl) secEl.textContent = pad(secs);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------------------------------------------------------------------
     Accordion — [data-tw-accordion] > [data-tw-accordion-item]
     Add data-single="true" on the wrapper to allow only one open at a time.
  --------------------------------------------------------------------- */
  function initAccordions() {
    var groups = document.querySelectorAll('[data-tw-accordion]');
    groups.forEach(function (group) {
      var single = group.getAttribute('data-single') === 'true';
      var items = group.querySelectorAll('[data-tw-accordion-item]');

      items.forEach(function (item) {
        var trigger = item.querySelector('.tw-accordion__trigger');
        var panel = item.querySelector('.tw-accordion__panel');
        var inner = item.querySelector('.tw-accordion__panel-inner');
        if (!trigger || !panel || !inner) return;

        function setState(open) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          item.classList.toggle('is-open', open);
          panel.style.maxHeight = open ? inner.scrollHeight + 'px' : '0px';
        }

        setState(item.classList.contains('is-open'));

        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          if (single && willOpen) {
            items.forEach(function (other) {
              if (other !== item) setState.call(other, false);
            });
            items.forEach(function (other) {
              if (other === item) return;
              var otherPanel = other.querySelector('.tw-accordion__panel');
              var otherTrigger = other.querySelector('.tw-accordion__trigger');
              if (otherPanel) otherPanel.style.maxHeight = '0px';
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              other.classList.remove('is-open');
            });
          }

          setState(willOpen);
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Tabs — [data-tw-tabs] with [data-tw-tab][data-target="id"] buttons
     and [data-tw-tab-panel][id]
  --------------------------------------------------------------------- */
  function initTabs() {
    var groups = document.querySelectorAll('[data-tw-tabs]');
    groups.forEach(function (group) {
      var tabs = group.querySelectorAll('[data-tw-tab]');
      var panels = group.querySelectorAll('[data-tw-tab-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-target');

          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');

          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-tw-tab-panel') !== target;
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Carousel + dots — [data-tw-carousel]
       [data-tw-carousel-track] (scrollable, children = slides)
       [data-tw-carousel-dots]  (populated dynamically)
  --------------------------------------------------------------------- */
  function initCarousels() {
    var carousels = document.querySelectorAll('[data-tw-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-tw-carousel-track]');
      var dotsWrap = carousel.querySelector('[data-tw-carousel-dots]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      var dots = [];
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'tw-dots__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
          dot.addEventListener('click', function () {
            slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        });
      }

      if (!dots.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = slides.indexOf(entry.target);
              if (index === -1) return;
              dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
            }
          });
        },
        { root: track, threshold: 0.6 }
      );

      slides.forEach(function (slide) { observer.observe(slide); });
    });
  }

  /* ---------------------------------------------------------------------
     Galería principal — [data-tw-gallery]
       [data-tw-gallery-main] con [data-tw-gallery-slide][data-index]
       [data-tw-gallery-thumbs] con [data-tw-gallery-thumb][data-index]
       [data-tw-gallery-prev] / [data-tw-gallery-next]
  --------------------------------------------------------------------- */
  function initGalleries() {
    var galleries = document.querySelectorAll('[data-tw-gallery]');
    galleries.forEach(function (gallery) {
      var main = gallery.querySelector('[data-tw-gallery-main]');
      var thumbsWrap = gallery.querySelector('[data-tw-gallery-thumbs]');
      if (!main) return;

      var slides = Array.prototype.slice.call(main.querySelectorAll('[data-tw-gallery-slide]'));
      var thumbs = thumbsWrap
        ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-tw-gallery-thumb]'))
        : [];
      var prevBtn = gallery.querySelector('[data-tw-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-tw-gallery-next]');
      var current = 0;

      function goTo(index) {
        if (!slides.length) return;
        index = (index + slides.length) % slides.length;
        slides[current].classList.remove('is-active');
        if (thumbs[current]) thumbs[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        if (thumbs[current]) {
          thumbs[current].classList.add('is-active');
          thumbs[current].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
      });

      var touchStartX = 0;
      main.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener(
        'touchend',
        function (e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) > 40) { dx < 0 ? goTo(current + 1) : goTo(current - 1); }
        },
        { passive: true }
      );
    });
  }

  /* ---------------------------------------------------------------------
     Video UGC — el visitante elige cuál reproducir, con audio
     [data-tw-video-item] > video.tw-video, [data-tw-video-play]
  --------------------------------------------------------------------- */
  function initVideoItems() {
    var items = document.querySelectorAll('[data-tw-video-item]');
    if (!items.length) return;

    function stop(item) {
      var video = item.querySelector('video');
      if (!video) return;
      video.pause();
      video.muted = true;
      item.classList.remove('is-playing');
    }

    function play(item) {
      var video = item.querySelector('video');
      if (!video) return;

      items.forEach(function (other) {
        if (other !== item) stop(other);
      });

      video.muted = false;
      item.classList.add('is-playing');
      video.play().catch(function () {
        video.muted = true;
        video.play().catch(function () {});
      });
    }

    items.forEach(function (item) {
      var video = item.querySelector('video');
      if (!video) return;

      item.addEventListener('click', function () {
        if (video.paused) play(item);
        else stop(item);
      });

      video.addEventListener('ended', function () {
        item.classList.remove('is-playing');
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) stop(entry.target);
          });
        },
        { threshold: 0.2 }
      );
      items.forEach(function (item) { observer.observe(item); });
    }
  }

  /* ---------------------------------------------------------------------
     Carga diferida de video — [data-tw-lazy-video][data-src]
     No asigna el src del <source> hasta que la sección es visible.
  --------------------------------------------------------------------- */
  function initLazyVideos() {
    var nodes = document.querySelectorAll('[data-tw-lazy-video]');
    if (!nodes.length) return;

    function load(node) {
      var video = node.tagName === 'VIDEO' ? node : node.querySelector('video');
      if (!video || video.dataset.twLoaded) return;
      var source = video.querySelector('source[data-src]');
      if (source) {
        source.setAttribute('src', source.getAttribute('data-src'));
        video.load();
      }
      video.dataset.twLoaded = 'true';
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(load);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            load(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    nodes.forEach(function (node) { observer.observe(node); });
  }

  /* ---------------------------------------------------------------------
     Añadir al carrito — un solo form principal, reutilizado por
     cualquier botón secundario con [data-tw-add-to-cart]
  --------------------------------------------------------------------- */
  /* Form "principal": el de TW Producto + bundles (data-tw-primary) o, si no
     existe, el primero de la página. Los CTA secundarios lo reutilizan. */
  function getPrimaryBuyForm() {
    return document.querySelector('[data-tw-buy-form][data-tw-primary]') ||
      document.querySelector('[data-tw-buy-form]');
  }

  function formatMoneyCents(cents) {
    return (parseInt(cents, 10) / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 });
  }

  /* Precio mostrado en los botones secundarios: sigue al bundle elegido arriba */
  function updateFollowPrices(cents) {
    document.querySelectorAll('[data-tw-follow-price]').forEach(function (el) {
      el.textContent = formatMoneyCents(cents);
    });
  }

  function initAddToCart() {
    var forms = document.querySelectorAll('[data-tw-buy-form]');

    forms.forEach(function (form) {
      initAddToCartForForm(form);
    });

    initSecondaryCtas();
  }

  /* Botones "Añadir al carrito" de otras secciones (comparación, garantía...):
     añaden exactamente lo que el cliente eligió en el selector de bundles. */
  function initSecondaryCtas() {
    document.querySelectorAll('[data-tw-secondary-cta]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var primary = getPrimaryBuyForm();
        if (primary && primary.__twSubmit) {
          primary.__twSubmit();
          return;
        }

        var variantId = btn.getAttribute('data-fallback-variant');
        if (!variantId) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            /* Carrito lateral: si está activo se abre solo (lo detecta el fetch); si no, vamos a /cart como antes */
            if (window.NoctapeCartDrawer && window.NoctapeCartDrawer.isActive()) { btn.disabled = false; return; }
            window.location.href = '/cart';
          })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  /* Cada form de compra queda aislado a la sección que lo contiene
     (el wrapper .shopify-section que Shopify genera automáticamente),
     así que dos selectores de bundle en la misma página no se pisan. */
  function initAddToCartForForm(form) {
    var root = form.closest('.shopify-section') || document;
    var redirectMode = form.getAttribute('data-redirect') || 'cart';
    var buttons = root.querySelectorAll('[data-tw-add-to-cart]');

    function setLoading(isLoading) {
      buttons.forEach(function (btn) {
        btn.disabled = isLoading;
      });
      if (form === getPrimaryBuyForm()) {
        document.querySelectorAll('[data-tw-secondary-cta]').forEach(function (btn) {
          btn.disabled = isLoading;
        });
      }
    }

    function submitBuy(e) {
      if (e) e.preventDefault();
      setLoading(true);

      var giftVariants = (form.dataset.giftVariants || '')
        .split(',')
        .map(function (v) { return v.trim(); })
        .filter(function (v) { return v; });

      var request;

      if (giftVariants.length) {
        var idInput = form.querySelector('input[name="id"]');
        var items = [{ id: idInput ? idInput.value : '', quantity: 1 }];
        giftVariants.forEach(function (variantId) {
          items.push({ id: variantId, quantity: 1 });
        });

        request = fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      } else {
        request = fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
      }

      request
        .then(function (res) { return res.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('tw:added-to-cart'));
          if (redirectMode === 'checkout') {
            window.location.href = '/checkout';
          } else if (!(window.NoctapeCartDrawer && window.NoctapeCartDrawer.isActive())) {
            /* Sin carrito lateral: comportamiento original */
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          setLoading(false);
        });
    }

    form.__twSubmit = submitBuy;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', submitBuy);
    });
  }

  /* ---------------------------------------------------------------------
     Barra sticky de compra en móvil
     [data-tw-sticky-bar] se muestra cuando [data-tw-buy-anchor] sale
     de pantalla.
  --------------------------------------------------------------------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-tw-sticky-bar]');
    var anchor = document.querySelector('[data-tw-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var hasBeenVisible = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hasBeenVisible = true;
          bar.classList.toggle('is-visible', hasBeenVisible && !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(anchor);
  }

  /* ---------------------------------------------------------------------
     Selector de bundles — [data-tw-bundle] > [data-tw-bundle-option]
     con input[data-tw-bundle-radio]. Solo la opción seleccionada se
     expande ([data-tw-bundle-expanded]). Actualiza precio, variante,
     regalos e imagen de galería.
  --------------------------------------------------------------------- */
  /* ------------------------------------------------------------
     Selector de packs — [data-tw-packs] > [data-tw-pack-option].
     Muestra solo los bundles ([data-tw-bundle-option][data-pack])
     del pack elegido y selecciona el primero visible, lo que
     actualiza variante, precio y botones con la lógica del bundle.
     ------------------------------------------------------------ */
  function initPackSelector() {
    var wrappers = document.querySelectorAll('[data-tw-packs]');

    wrappers.forEach(function (wrapper) {
      if (wrapper.__twPacksReady) return;
      wrapper.__twPacksReady = true;

      var scope = wrapper.parentElement;
      var bundle = scope && scope.querySelector('[data-tw-bundle]');
      var options = wrapper.querySelectorAll('[data-tw-pack-option]');
      if (!bundle || !options.length) return;

      function applyPack(pack, userAction) {
        options.forEach(function (opt) {
          var on = opt.getAttribute('data-pack') === String(pack);
          opt.classList.toggle('is-selected', on);
          var radio = opt.querySelector('[data-tw-pack-radio]');
          if (radio) radio.checked = on;
        });

        var visible = [];
        bundle.querySelectorAll('[data-tw-bundle-option]').forEach(function (opt) {
          var p = opt.getAttribute('data-pack') || '0';
          var show = p === '0' || p === String(pack);
          opt.hidden = !show;
          if (show) visible.push(opt);
        });

        if (!userAction) return;

        var current = null;
        visible.forEach(function (opt) {
          if (opt.classList.contains('is-selected')) current = opt;
        });
        var target = current || visible.filter(function (opt) {
          return opt.hasAttribute('data-tw-default');
        })[0] || visible.filter(function (opt) {
          return !opt.classList.contains('is-sold-out');
        })[0] || visible[0];

        if (target) {
          var radio = target.querySelector('[data-tw-bundle-radio]');
          if (radio && !radio.disabled) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      options.forEach(function (opt) {
        var radio = opt.querySelector('[data-tw-pack-radio]');
        if (!radio) return;
        radio.addEventListener('change', function () {
          if (radio.checked) applyPack(opt.getAttribute('data-pack'), true);
        });
      });

      var checked = wrapper.querySelector('[data-tw-pack-radio]:checked');
      applyPack(checked ? checked.value : '1', false);
    });
  }

  function initBundleSelector() {
    var wrappers = document.querySelectorAll('[data-tw-bundle]');

    wrappers.forEach(function (wrapper) {
      /* Cada selector queda aislado a su propia sección (el wrapper
         .shopify-section que Shopify genera por sección), para que dos
         bundles en la misma página no se pisen entre sí. */
      var root = wrapper.closest('.shopify-section') || document;
      var options = wrapper.querySelectorAll('[data-tw-bundle-option]');
      var form = root.querySelector('[data-tw-buy-form]');

      function formatMoney(cents) {
        return (cents / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 });
      }

      function updatePriceDisplays(cents) {
        root.querySelectorAll('[data-tw-price-display]').forEach(function (el) {
          el.textContent = formatMoney(parseInt(cents, 10));
        });
      }

      function selectOption(option) {
        options.forEach(function (opt) {
          var expanded = opt.querySelector('[data-tw-bundle-expanded]');
          var isSelected = opt === option;
          opt.classList.toggle('is-selected', isSelected);
          if (expanded) expanded.style.maxHeight = isSelected ? expanded.scrollHeight + 'px' : '0px';
        });

        var price = option.getAttribute('data-price');
        var image = option.getAttribute('data-image');
        var variantId = option.getAttribute('data-variant-id');

        if (price) updatePriceDisplays(price);
        if (price && form && form === getPrimaryBuyForm()) updateFollowPrices(price);

        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;
          form.dataset.giftVariants = option.getAttribute('data-gift-variants') || '';
        }

        if (image) {
          var activeSlideImg = root.querySelector('.tw-gallery__slide.is-active img');
          if (activeSlideImg) activeSlideImg.src = image;
          var stickyThumbImg = root.querySelector('[data-tw-sticky-bar] img');
          if (stickyThumbImg) stickyThumbImg.src = image;
        }
      }

      options.forEach(function (option) {
        var radio = option.querySelector('[data-tw-bundle-radio]');
        if (!radio) return;

        radio.addEventListener('change', function () {
          if (radio.checked) selectOption(option);
        });

        if (radio.checked) selectOption(option);
      });

      var oneTimeLink = wrapper.querySelector('[data-tw-bundle-onetime]');
      if (oneTimeLink) {
        oneTimeLink.addEventListener('click', function (e) {
          e.preventDefault();

          options.forEach(function (opt) {
            opt.classList.remove('is-selected');
            var radio = opt.querySelector('[data-tw-bundle-radio]');
            if (radio) radio.checked = false;
            var expanded = opt.querySelector('[data-tw-bundle-expanded]');
            if (expanded) expanded.style.maxHeight = '0px';
          });

          var variantId = oneTimeLink.getAttribute('data-variant-id');
          var price = oneTimeLink.getAttribute('data-price');

          if (form) {
            var idInput = form.querySelector('input[name="id"]');
            if (idInput) idInput.value = variantId;
            form.dataset.giftVariants = '';
          }
          if (price) updatePriceDisplays(price);
          if (price && form && form === getPrimaryBuyForm()) updateFollowPrices(price);
        });
      }
    });
  }

  ready(function () {
    initCountdowns();
    initAccordions();
    initTabs();
    initCarousels();
    initGalleries();
    initVideoItems();
    initLazyVideos();
    initPackSelector();
    initBundleSelector();
    initAddToCart();
    initStickyBar();
  });
})();
